module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"play":"Video abspielen"},"en":{"play":"Play video"},"it":{"play":""},"lt":{"play":"Žiūrėti video įrašą"},"pl":{"play":"Włącz wideo"}}')
  delete Component.options._Ctor
}
